<div class="tw-mb-4">
  <app-cipher-view [cipher]="cipher()" [hasAnonymousPremium]="true"></app-cipher-view>
</div>
